module.exports = __webpack_public_path__ + "media/images/home-hero-image-be462fadd18250e9a2251748cb5ce479.jpg";